module.exports = __webpack_public_path__ + "img/3.aa35727d.png";